<template>
  <el-dialog title="生产非套码222"
             :visible.sync="visible"
             width="420px"
             @close='handleClose'
             :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="produceInfo"
             v-loading="loading"
             :rules="rules"
             ref="ruleForm"
             label-width="120px">
      <el-form-item label="标签类型:"
                    prop="tagType">
        <vendor-label-select style="width:220px"
                             v-model="produceInfo.tagType"
                             :exclude="[1,5]"
                             :option="{vendorId: produceInfo.refVendorId}" />
        <!-- <el-select v-model="produceInfo.tagType"
          placeholder="请选择标签类型:">
          <el-option v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item label="生产数量:"
                    prop="tagCount">
        <el-input-number v-model="produceInfo.tagCount"
                         style="width:220px"
                         :controls="false"
                         :min="1"
                         :max="5000000"
                         @blur="handleBlur"
                         @focus="handleFocus"
                         :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item label="起止序号:">
        <span v-if="tagRange.beginTagNo">{{tagRange.beginTagNo | tagCount() }} - {{tagRange.endTagNo | tagCount() }}</span>
      </el-form-item>
      <el-form-item label="是否涂层:"
                    v-if="produceInfo.tagType === 3">
        <el-radio-group v-model="produceInfo.tagHasCoat">
          <el-radio :label="0">无涂层</el-radio>
          <el-radio :label="1">有涂层</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注:"
                    prop="remarks">
        <el-input v-model="produceInfo.remarks"
                  type="textarea"
                  placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="toggleModal(false)"
                 :loading="loading">取 消</el-button>
      <el-button type="primary"
                 :disabled="disabled"
                 @click="addtagsegment"
                 :loading="loading">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import VendorLabelSelect from './vendor-label-select.vue'
import Data from './index'
// let t
export default {
  name: 'tag-produce-modal',
  components: { VendorLabelSelect },
  props: {
    fetch: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      visible: false,
      options: Data.tags,
      vendorName: '',
      produceInfo: {
        tagType: null,
        tagCount: undefined,
        refVendorId: '',
        tagHasCoat: 0,
        remarks: ''
      },
      disabled: true,
      tagRange: {},
      rules: {
        tagType: [{ required: true, message: '请选择标签类型', trigger: 'change' }],
        tagCount: [{ required: true, message: '请输入生产套数', trigger: 'blur' }]
      }
    }
  },
  watch: {
    produceInfo: {
      handler (val, oldVal) {
        if (val.tagType && val.tagCount) {
          // clearTimeout(t)
          // t = setTimeout(() => {
          //   this.getnexttagsegmentinfo()
          // }, 1000)
          this.getnexttagsegmentinfo()
        }
      },
      deep: true
    }
  },
  methods: {
    init (options) {
      this.produceInfo.refVendorId = options.vendorId
      this.vendorName = options.vendorName
      this.toggleModal(true)
    },
    toggleModal (visible) {
      this.visible = visible
    },
    handleBlur () {
      setTimeout(() => {
        this.disabled = false
      }, 1000)
    },
    handleFocus () {
      this.disabled = true
    },
    handleClose () {
      this.$refs.ruleForm.resetFields()
      this.disabled = true
      this.tagRange = {}
      this.produceInfo = {
        tagType: null,
        tagCount: undefined,
        refVendorId: ''
      }
    },
    addtagsegment () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('label/addtagsegment', {
            payload: {
              ...this.produceInfo,
              isPreassign: 1
            },
            success: (res) => {
              this.loading = false
              this.toggleModal(false)
              this.fetch(true)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    getnexttagsegmentinfo () {
      if (!this.produceInfo.tagType || !this.produceInfo.tagCount) {
        return
      }
      this.loading = true
      this.$store.dispatch('label/getnexttagsegmentinfo', {
        payload: {
          tagType: this.produceInfo.tagType,
          tagCount: this.produceInfo.tagCount,
          vendorId: this.produceInfo.refVendorId
        },
        success: (res) => {
          this.loading = false
          this.tagRange = res.data
        },
        fail: () => {
          this.loading = false
          this.tagRange = {}
        }
      })
    }
  }
}
</script>
